export default "__VITE_ASSET__CZW45RJH__"